module.exports = __webpack_public_path__ + "static/media/slide1.dc1bf326.webp";